import { createRoot } from 'react-dom/client';

import Search from '@App/components/MapSearch/MapSearch';

import './search-control.css';

class SearchControl {
  constructor(map, navigate) {
    this._container = null;
    this._root = null;
    this._menuObserver = null;
    this.map = map;
    this.navigate = navigate;
  }

  onAdd() {
    this._container = document.createElement('div');
    this._container.className = `maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-search`;

    const updateMenuState = () => {
      const isMenuOpen = document.querySelector('#portal .map-search__search__menu') !== null;
      this.map.getContainer().classList.toggle('map--search-menu-open', isMenuOpen);
    };

    this._menuObserver = new MutationObserver(updateMenuState);
    this._menuObserver.observe(document.body, { childList: true, subtree: true });

    this._root = createRoot(this._container);
    this._root.render(<Search navigate={this.navigate} />);

    return this._container;
  }

  onRemove() {
    this._menuObserver?.disconnect();
    this.map.getContainer().classList.remove('map--search-menu-open');
    if (this._root) {
      queueMicrotask(() => {
        this._root.unmount();
      });
    }
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
  }
}

export default SearchControl;
